function StorageDeleteConfirmModal({ item, onCancel, onConfirm }) {
  if (!item) return null;

  return (
    <div className="fixed inset-0 z-[95] flex items-center justify-center bg-slate-900/35 p-4">
      <div className="w-full max-w-md rounded-2xl border border-slate-200 bg-white p-5 shadow-2xl">
        <h3 className="text-base font-bold text-slate-900">Delete item?</h3>
        <p className="mt-2 text-sm text-slate-600">
          This will delete <span className="font-semibold text-slate-900">{item.name || 'this item'}</span>.
          {item.type === 'folder' ? ' Folders must be empty before deletion.' : ''}
        </p>
        <div className="mt-4 flex justify-end gap-2">
          <button
            type="button"
            className="rounded-lg border border-slate-200 px-3 py-2 text-sm font-semibold text-slate-700 transition hover:bg-slate-100"
            onClick={onCancel}
          >
            Cancel
          </button>
          <button
            type="button"
            className="rounded-lg bg-red-600 px-3 py-2 text-sm font-semibold text-white transition hover:bg-red-700"
            onClick={() => onConfirm(item)}
          >
            Delete
          </button>
        </div>
      </div>
    </div>
  );
}

export default StorageDeleteConfirmModal;
